<template>
  <div class="content no-icon-shape">
    <modal-loading
      :openModal="
        fetchProgress > 0 &&
        fetchProgress < 100 &&
        (showSplash == true || $route.path == '/reports/visits')
      "
      :value="fetchProgress"
      :class="
        $route.path == '/reports/visits/dashboard' && showSplash == true
          ? 'full-modal'
          : ''
      "
      style="width: 15em"
      :background_img="
        this.$route.path == '/reports/visits/dashboard'
          ? `img/janoo-icon-high-color.png`
          : ``
      "
      :label="'carregando... ' + fetchProgress.toFixed(0) + '%'"
    >
    </modal-loading>

    <dashboard-page :title="reportMode == 'erp' ? erpReportTitle : 'Visitação'">
      <base-header class="pb-6">
        <b-row align-h="end" align-v="center" class="mb--2">
          <b-col
            align-self="center"
            class="col-2 ml-auto text-right"
            v-if="reportMode != 'erp'"
          >
            <base-button
              class="btn-sm btn-outline-info"
              :disabled="Object.keys(billItensList).length > 0 ? false : true"
              @click="openModalTabelaReservas()"
              :loading="loadingTable"
              type="submit"
              >Listar reservas
            </base-button>
          </b-col>

          <!-- DROPDOWN MENU-->
          <b-row
            align-self="start"
            class="row-1 text-right mr-4"
            v-if="reportMode != 'erp'"
          >
            <b-dropdown
              menu
              on
              right
              no-caret
              id="dropdown-1"
              variant="secondary"
            >
              <template v-slot:button-content>
                <svg
                  width="5"
                  height="19"
                  viewBox="0 0 5 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="2.19231"
                    cy="2.19231"
                    r="2.19231"
                    fill="#12576e"
                  />
                  <circle
                    cx="2.19231"
                    cy="9.49992"
                    r="2.19231"
                    fill="#12576e"
                  />
                  <circle
                    cx="2.19231"
                    cy="16.8078"
                    r="2.19231"
                    fill="#12576e"
                  />
                </svg>
              </template>

              <b-dropdown-item
                @click="downloadAsAssocCSV"
                :disabled="Object.keys(billItensList).length > 0 ? false : true"
                :loading="loadingTable"
                type="primary"
              >
                <i v-if="!loadingTable" class="no no-data-download"></i
                >Relatório de atuação por associação
              </b-dropdown-item>

              <b-dropdown-item
                @click="downloadAsAgentCSV"
                :disabled="Object.keys(billItensList).length > 0 ? false : true"
                :loading="loadingTable"
                type="primary"
              >
                <i v-if="!loadingTable" class="no no-data-download"></i
                >Relatório de atuação por condutor
              </b-dropdown-item>

              <b-dropdown-item
                @click="downloadAsCSV"
                :disabled="Object.keys(billItensList).length > 0 ? false : true"
                :loading="loadingTable"
                type="primary"
              >
                <i v-if="!loadingTable" class="no no-data-download"></i
                >Relatório de visitação
              </b-dropdown-item>

              <!-- <b-dropdown-item @click="openModalTabelaReservas()" :disabled="transformedItems.length == 0" :loading="loadingTable" md="0" ml="auto" type="submit">
              <i v-if="!loadingTable" class="fas fa-list-ol"></i>Lista de Reservas
            </b-dropdown-item> -->
            </b-dropdown>
          </b-row>
        </b-row>

        <b-row>
          <b-col align-self="center" sm="6" class="mb-0">
            <h6 class="h5 d-inline-block mb-4 text-gray">
              <div v-if="reportMode == 'erp'">
                <!-- <div v-if="(fetchProgress > 0 && fetchProgress < 100)">
                  <i class="fas fa-spinner fa-spin"></i>
                  atualizando...
                </div>
                <div v-else>
                  Última atualização:
                  {{ `${(new Date(getChartCacheLimit - cacheDurationTime * 60000)).toLocaleString()}` }}
                </div> -->
                {{
                  fetchProgress > 0 && fetchProgress < 100
                    ? 'atualizando...'
                    : lastReportUpdate
                }}
              </div>
            </h6>
          </b-col>
        </b-row>

        <b-row
          align-h="start"
          align-v="center"
          class="mb-4 mt--2"
          v-if="reportMode != 'erp'"
        >
          <!-- || true for tests (show date) -->
          <b-col align-self="start" sm="6" md="2" class="mb-1">
            <date-picker
              v-model="formDate.startDate"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              class="w-100"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </date-picker>
          </b-col>

          <b-col align-self="start" md="2" sm="6" class="mb-1">
            <date-picker
              v-model="formDate.endDate"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              class="w-100"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </date-picker>
          </b-col>

          <b-col class="text-left col-2">
            <base-button
              @click="loadReport"
              :disabled="!formDate.startDate || !formDate.endDate"
              :loading="loadingTable"
              type="submit"
              class="btn btn-outline-info"
            >
              Filtrar
            </base-button>
          </b-col>
        </b-row>
        <!-- DROPDOWN MENU-->
      </base-header>

      <b-container fluid class="mt--6">
        <div
          v-if="false"
          style="width: auto; margin-left: 15px; margin-bottom: 30px"
        >
          <div v-if="Object.keys(pois).length > 1 && reportMode != 'erp'">
            <b-row>
              <h3 class="mb-0 mr-4 ml-1 align-self-center">
                Filtrar resultados por Passeio
              </h3>

              <base-button
                @click="showFilterSearch = !showFilterSearch"
                icon
                type="primary"
                class="col-2"
                size="sm"
                :class="
                  Object.keys(billItensList).length ==
                  filteredbillItensList.length
                    ? 'btn-sm'
                    : 'btn-info'
                "
                title="filtrar os resultados da busca"
              >
                <span class="btn-inner--icon">
                  <i
                    :class="
                      showFilterSearch
                        ? 'no no-lg no-up-arrow mt-1'
                        : 'no-lg no no-down-arrow mt-1'
                    "
                  ></i>
                </span>
              </base-button>
            </b-row>

            <search-filter-visits
              v-if="!loadingFilter"
              ref="searchFilter"
              :allItems="pois"
              :currentItems="billItensList"
              :visible="showFilterSearch"
              :productName="productName"
              :categoryName="'category'"
              :class="`my-0 py-0`"
              @billItensSelected="setInputbillItens"
            />
          </div>
        </div>

        <b-row>
          <b-col v-if="reportMode == 'erp'" xs="12" sm="12" md="3" lg="3">
            <b-card class="subcard-p-3">
              <h3 class="card-title mb-0">Ontem</h3>
              <p
                v-if="useChartCache || fetchProgress == 100"
                class="text-gray mb-0"
              >
                <b>{{ yesterdayTotalClients }}</b> visitantes
              </p>
            </b-card>
          </b-col>

          <b-col v-if="reportMode == 'erp'" xs="12" sm="12" md="6" lg="4">
            <b-card class="subcard-p-3">
              <h3 class="card-title mb-0">Hoje</h3>
              <div v-if="useChartCache || fetchProgress == 100">
                <p
                  v-for="(item, key) in todayTotalClients"
                  :key="key"
                  class="text-gray d-md-inline"
                >
                  <b>{{ item.value }}</b> {{ item.title }}
                  {{
                    key != todayTotalClients.length - 1
                      ? ' | '
                      : '(' + todayTotalClientsPercentage + '%) '
                  }}
                </p>
              </div>
            </b-card>
          </b-col>

          <b-col v-if="reportMode == 'erp'" xs="12" sm="12" md="3" lg="2">
            <b-card class="subcard-p-3">
              <h3 class="card-title mb-0">Amanhã</h3>
              <p
                v-if="useChartCache || fetchProgress == 100"
                class="text-gray mb-0"
              >
                <b>{{ tomorrowTotalClients }}</b> agendados
              </p>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-12" sm="12" md="3" lg="3">
            <b-card class="subcard-p-3">
              <h3 class="card-title mb-0">Duração</h3>
              <div v-if="useChartCache || fetchProgress == 100">
                <p class="text-gray d-inline">
                  <b>{{ totalDays }}</b> dias
                </p>
              </div>

              <div
                class="mt-2 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para ver mais detalhes
                </h4>
              </div>
            </b-card>
          </b-col>

          <b-col class="col-12" sm="12" md="9" lg="6">
            <b-card class="subcard-p-3">
              <h3 class="card-title mb-0">
                {{ `${clientsCountItemName}` }} no período
              </h3>
              <div v-if="useChartCache || fetchProgress == 100">
                <p
                  v-for="(item, key) in filteredbillItensAmount"
                  :key="key"
                  class="text-gray d-inline"
                >
                  <b>{{ item.value }}</b> {{ item.title }}
                  {{
                    key == filteredbillItensAmount.length - 2
                      ? ` (${periodTotalClientsPercentage}%)`
                      : ''
                  }}
                  {{ key != filteredbillItensAmount.length - 1 ? ' | ' : '' }}
                </p>
              </div>

              <div
                class="mt-2 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para ver mais detalhes
                </h4>
              </div>
            </b-card>
          </b-col>

          <b-col
            v-if="filteredbillItensList.length > 1"
            class="col-12"
            sm="12"
            md="12"
            lg="3"
          >
            <b-card class="subcard-p-3">
              <h3 class="card-title mb-0">
                {{
                  `${
                    productNameComplement.substring(0, 1).toUpperCase() +
                    productNameComplement.substring(1)
                  }`
                }}
              </h3>

              <div v-if="useChartCache || fetchProgress == 100">
                <p class="text-gray d-md-inline">
                  <b>{{ filteredbillItensList.length }}</b> {{ productName }}
                </p>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            v-if="reportMode != 'erp'"
            :class="`${false ? 'col-md-12 col-sm-12' : 'col-12'}`"
          ></b-col>
        </b-row>

        <b-row>
          <b-col :class="reportMode == 'erp' ? 'col-md-9 col-sm-12' : 'col-12'">
            <b-card
              v-if="useChartCache || fetchProgress == 100"
              class="no-border-card"
              body-classes="py-0"
              footer-classes="py-0"
            >
              <div class="row">
                <h3 class="mb-0 pr-0 col-md-6 col-sm-12">
                  {{ clientsCountItemName }}
                </h3>

                <div class="mb-0 pr-0 pl-0 text-right col-md-6 col-sm-12">
                  <base-button
                    v-show="!reportMode"
                    type="primary"
                    outline
                    :class="{ active: chartTotalView === 'semester' }"
                    @click="chartTotalView = 'semester'"
                    class="btn btn-sm mr-1"
                  >
                    semestre
                  </base-button>

                  <base-button
                    v-show="!reportMode"
                    type="primary"
                    outline
                    :class="{ active: chartTotalView === 'month' }"
                    @click="chartTotalView = 'month'"
                    class="btn btn-sm"
                  >
                    mês
                  </base-button>

                  <base-button
                    type="primary"
                    outline
                    :class="{ active: chartTotalView === 'day' }"
                    @click="chartTotalView = 'day'"
                    class="btn btn-sm"
                  >
                    data
                  </base-button>

                  <base-button
                    type="primary"
                    outline
                    :class="{ active: chartTotalView === 'week' }"
                    @click="chartTotalView = 'week'"
                    class="btn btn-sm"
                  >
                    semana
                  </base-button>

                  <base-button
                    type="primary"
                    outline
                    :class="{ active: chartTotalView === 'weekday' }"
                    @click="chartTotalView = 'weekday'"
                    class="btn btn-sm"
                  >
                    dia da semana
                  </base-button>
                </div>
              </div>

              <div class="pt-5">
                <bar-chart-visitantes
                  v-if="useChartCache || fetchProgress == 100"
                  :height="250"
                  style="max-height: 100%"
                  :clientsCountItemName="clientsCountItemName"
                  :filteredDataCharts="filteredDataCharts"
                  :todayReferenceDate="todayReferenceDate"
                  :colors="colors"
                  :chartTotalView="chartTotalView"
                  :fetchProgress="fetchProgress"
                  :endDate="formDate.endDate"
                  @changeUseChartCache="changeUseChartCache"
                >
                </bar-chart-visitantes>
              </div>
            </b-card>
          </b-col>

          <b-col v-if="reportMode == 'erp'" class="col-md-3 col-sm-12">
            <b-row>
              <b-col class="col-12">
                <b-card class="subcard-p-3">
                  <h3 class="card-title mb-0">Este mês</h3>

                  <b-row v-if="useChartCache || fetchProgress == 100" sm>
                    <b-col
                      class="col-12"
                      v-if="filteredbillItensList.length > 1"
                    >
                      <p class="mb-0">
                        <strong> {{ `${productName}:` }} </strong>
                      </p>
                      <p class="text-gray">
                        {{ filteredbillItensList.length }}
                      </p>
                    </b-col>

                    <b-col
                      v-for="(item, key) in filteredbillItensAmount"
                      :key="key"
                      class="col-12"
                    >
                      <p class="mb-0">
                        <strong>{{ `${item.title}:` }}</strong>
                      </p>
                      <p class="text-gray">{{ item.value }}</p>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- FIM SEÇÃO CARDS -->

        <!-- SEÇÃO GRÁFICOS -->
        <b-row>
          <b-col
            v-if="Object.keys(pois).length > 1 || otherPOIs.length > 0"
            xl="6"
          >
            <!--GRAFICO BARRA RANKING ITENS POR QUANTIDADE (NUM VISITANTES)-->
            <b-card
              class="no-border-card"
              body-classes="px-0 pb-1"
              footer-classes="pb-2"
            >
              <template v-slot:header>
                <h3 class="mb-0">Mais {{ productNameComplement }}</h3>
              </template>

              <div
                class="mt-2 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para ver um gráfico.
                </h4>
              </div>

              <div
                v-if="useChartCache || fetchProgress == 100"
                class="chart-area"
              >
                <bar-chart-ranking-visitantes
                  :defaultBarThickness="defaultBarThickness"
                  :maxBarThickness="maxBarThickness"
                  :filteredbillItensList="filteredbillItensList"
                  :colors="colors"
                  :filteredDataCharts="filteredDataCharts"
                  :selectedbillItensNames="selectedbillItensNames"
                  :verticalChartMaxLines="verticalChartMaxLines"
                  :fetchProgress="fetchProgress"
                >
                </bar-chart-ranking-visitantes>
              </div>
            </b-card>
          </b-col>

          <b-col
            v-if="Object.keys(pois).length > 1 || otherPOIs.length > 0"
            xl="6"
          >
            <!--GRAFICO BARRA QUANTIDADE <categoria> DO <nome> -->
            <b-card
              class="no-border-card"
              body-classes="px-0 pb-1"
              footer-classes="pb-2"
            >
              <template v-slot:header>
                <div class="row">
                  <h3 class="mb-0 pr-0 col-12 col-12">{{ productCategory }}</h3>
                </div>
              </template>

              <div
                class="mt-2 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para ver mais detalhes
                </h4>
              </div>

              <doughnut-chart-atrativo
                v-if="useChartCache || fetchProgress == 100"
                :height="250"
                :selectedbillItensNames="selectedbillItensNames"
                :defaultBarThickness="defaultBarThickness"
                :colors="colors"
                :byCityGraphLevel="byCityGraphLevel"
                :transformedItemsArray="transformedItemsArray"
                :fetchProgress="fetchProgress"
              >
              </doughnut-chart-atrativo>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col xl="6">
            <!-- Tamanho de Groupo -->
            <b-card
              class="no-border-card"
              body-classes="px-0 pb-1"
              footer-classes="pb-2"
            >
              <template v-slot:header>
                <div class="row">
                  <h3 class="mb-0 pr-0 col-md-12 col-sm-12">
                    Tamanho de {{ billName }}
                  </h3>
                </div>
              </template>

              <div
                class="ml-3 mt-0 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para visualizar um gráfico sobre Tamanhos
                  de Grupos.
                </h4>
              </div>

              <bar-chart-tamanho
                v-if="useChartCache || fetchProgress == 100"
                :height="250"
                :tableData="filteredDataCharts"
                :fetchProgress="fetchProgress"
                :clientsCountItemName="clientsCountItemName"
                :billName="billName"
                :selectedbillItensNames="selectedbillItensNames"
                :defaultBarThickness="defaultBarThickness"
                :colors="colors"
                :plurals="plurals"
                @changeUseChartCache="changeUseChartCache"
              >
              </bar-chart-tamanho>
            </b-card>
          </b-col>

          <b-col xl="6">
            <!--GRAFICO BARRA HORARIO VISITACAO vs CHECKIN -->
            <b-card
              class="no-border-card"
              body-classes="px-0 pb-1"
              footer-classes="pb-2"
            >
              <template v-slot:header>
                <div class="row">
                  <h3 class="mb-0 pr-0 col-md-12 col-sm-12">
                    Horários de {{ billItemName.slice(0, -1) }} e
                    {{ finishedBillName }}
                  </h3>
                </div>
              </template>

              <div
                class="ml-3 mt-0 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para visualizar um gráfico da relação
                  reserva x checkin.
                </h4>
              </div>
              <bar-chart-horario
                v-if="
                  filteredDataCharts.length > 0 &&
                  (useChartCache || fetchProgress == 100)
                "
                :height="250"
                :tableData="filteredDataCharts"
                :fetchProgress="fetchProgress"
                :clientsCountItemName="clientsCountItemName"
                :finishedBillName="finishedBillName"
                :selectedbillItensNames="selectedbillItensNames"
                :defaultBarThickness="defaultBarThickness"
                :colors="colors"
                :billItemName="billItemName"
                @changeUseChartCache="changeUseChartCache"
              >
              </bar-chart-horario>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col xl="6">
            <b-card
              class="no-border-card"
              body-classes="px-0 pb-1"
              footer-classes="pb-2"
            >
              <template v-slot:header>
                <div class="row">
                  <h3 class="mb-0 pr-0 col-md-12 col-sm-12">
                    Produtividade por Operador de portaria
                  </h3>
                </div>
              </template>

              <div
                class="ml-3 mt-0 d-flex"
                v-if="!useChartCache && fetchProgress == 0"
              >
                <i class="mt-1 no no-lg no-database" style="color: dimgrey"></i>
                <h4 class="mb-0 ml-2" style="font-weight: 400; color: dimgrey">
                  Selecione um período para visualizar um gráfico de
                  Produtividade por Operador.
                </h4>
              </div>

              <bar-chart-produtividade
                v-if="useChartCache || fetchProgress == 100"
                :height="250"
                :filteredDataCharts="filteredDataCharts"
                :defaultBarThickness="defaultBarThickness"
                :verticalChartMaxLines="verticalChartMaxLines"
                :fetchProgress="fetchProgress"
                @changeUseChartCache="changeUseChartCache"
              >
              </bar-chart-produtividade>
            </b-card>
          </b-col>
        </b-row>
        <!-- FIM SEÇÃO GRÁFICOS -->
      </b-container>

      <modal-tabela-reservas
        :showModalTabelaReservas="showModalTabelaReservas"
        :hideWhilePrintingPDF="false"
        :transformedItemsArray="transformedItemsArray"
        @emitCloseModalTabelaReservas="closeModalTabelaReservas"
      >
      </modal-tabela-reservas>
    </dashboard-page>
  </div>
</template>
<script type="text/javascript">
import swal from 'sweetalert2'
import moment from 'moment'
import BarChartVisitantes from './Charts/BarChartVisitantes.vue'
import BarChartTamanho from './Charts/BarChartTamanho.vue'
import BarChartVisitacao from './Charts/BarChartVisitacao.vue'
import BarChartRankingArrecadacao from './Charts/BarChartRankingArrecadacao.vue'
import BarChartRankingVisitantes from './Charts/BarChartRankingVisitantes.vue'
import BarChartHorario from './Charts/BarChartHorario.vue'
import BarChartProdutividade from './Charts/BarChartProdutividade.vue'
import DoughnutChartAtrativo from './Charts/DoughnutChartAtrativo.vue'
import { DatePicker } from 'element-ui'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import SearchFilterVisits from './SearchFilterVisits.vue'
import colors from '@/store/utils/colors'
import { mapActions, mapGetters } from 'vuex'
import { computed } from 'vue'
import ModalTabelaReservas from './ModalTabelaReservas.vue'
import store from '@/store'

export default {
  component: 'VisitsReport',

  components: {
    colors,
    DatePicker,
    SearchFilterVisits,
    BarChartVisitantes,
    BarChartTamanho,
    BarChartVisitacao,
    BarChartRankingArrecadacao,
    BarChartRankingVisitantes,
    BarChartHorario,
    BarChartProdutividade,
    DoughnutChartAtrativo,
    ModalLoading,
    ModalTabelaReservas,
  },

  provide() {
    return {
      startDate: computed(() => this.formDate.startDate),
      endDate: computed(() => this.formDate.startDate),
    }
  },

  watch: {
    transformedItemsArray(novo, old) {
      var tam = this.groupBy(novo, (val) => val.poi.product_name).map(function (
        val,
        idx
      ) {
        return val[0]
      }).length
      if (tam > 1) {
        this.showCharts = true
      } else {
        this.showCharts = false
      }
    },

    async $route(to, from) {
      if (
        from.path == '/reports/visits/dashboard' &&
        to.path == '/reports/visits'
      ) {
        clearTimeout(this.reportReloadTimeout)
        this.formDate.startDate = ''
        this.formDate.endDate = ''
        await this.productStoreCommit({
          mutation: 'SET_USE_CHART_CACHE',
          value: false,
        })
        this.fetchProgress = 0
      } else {
        await this.productStoreCommit({
          mutation: 'RESET_FILTERED_BILL_ITENS_AMOUNT',
        })
        await this.reportStoreCommit({ mutation: 'RESET_TRANSFORMED_ITEMS' })
        this.fillsFormDate()
        if (this.isCacheValid()) {
          await this.productStoreCommit({
            mutation: 'SET_USE_CHART_CACHE',
            value: true,
          })
        } else {
          await this.productStoreCommit({
            mutation: 'SET_USE_CHART_CACHE',
            value: true,
          }) //comment for test cache (disable)
          this.loadReport()
        }
      }
    },
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
      place: 'getPlace',
      params: 'params',
    }),

    ...mapGetters('product', {
      pois: 'getPois',
      stateYesterdayTotalClients: 'getStateYesterdayTotalClients',
      stateTomorrowTotalClients: 'getStateTomorrowTotalClients',
      stateTodayTotalClients: 'getStateTodayTotalClients',
      stateFilteredBillItensAmount: 'getStateFilteredBillItensAmount',
      useChartCache: 'getUseChartCache',
      getChartCacheLimit: 'getChartCacheLimit',
    }),

    ...mapGetters('report', {
      transformedItems: 'getBookings',
      reportReloadTimeout: 'getReportReloadTimeout',
      showSplash: 'getShowSplash',
    }),

    ...mapGetters('trafx', {
      trafxEntries: 'getTrafxEntries',
    }),

    monthNames() {
      return [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ]
    },

    colors() {
      return colors.colors
    },

    lastReportUpdate() {
      return `atualizado ${moment(
        this.getChartCacheLimit - this.cacheDurationTime * 60000
      ).format('DD/MM/YY HH:mm')}`
    },

    noCheckinCount() {
      var no_checkin_count = 0

      this.filteredDataCharts.map(function (value, index) {
        if (value.status == 'APPROVED' && !value.checkin.hasCheckin) {
          no_checkin_count += value.people.tableText.count
        }
      })

      return no_checkin_count
    },

    todayTotalClientsPercentage() {
      return this.todayTotalClients[0].value > 0
        ? (
            (this.todayTotalClients[1].value /
              this.todayTotalClients[0].value) *
            100.0
          ).toFixed(0)
        : 0
    },

    periodTotalClientsPercentage() {
      let bills = this.filteredDataCharts
      let billItemsFilteredTotalCount = 0

      if (bills.length) {
        billItemsFilteredTotalCount = this.getReducedPeopleAmount(bills)
      }
      if (billItemsFilteredTotalCount == 0) {
        return 0
      }

      return (
        ((billItemsFilteredTotalCount - this.noCheckinCount) * 100) /
        billItemsFilteredTotalCount
      )
        .toFixed(0)
        .replace('.', ',')
    },

    erpReportTitle() {
      return (
        // 'Análise mensal: ' +
        moment(this.formDate.startDate).format('DD') +
        ' a ' +
        moment(this.formDate.endDate).format('DD') +
        ' de ' +
        moment(this.formDate.startDate).format('MMMM') +
        ' de ' +
        moment(this.formDate.startDate).format('YYYY')
      )
    },

    todayTotalClients() {
      let todayTotalPeopleData = [
        { title: 'confirmados', value: 0 },
        { title: 'checkin', value: 0 },
      ]
      let date = moment(this.todayReferenceDate).format('YYYY-MM-DD')
      let bills = this.filteredDataCharts.filter(function (val, idx) {
        return val.data.indexOf(date) === 0
      })
      let todayTotalPeoapleCount = 0

      if (
        this.useChartCache &&
        this.stateTodayTotalClients != undefined &&
        this.stateTodayTotalClients != null &&
        this.stateTodayTotalClients[0] != undefined &&
        this.stateTodayTotalClients[0].value > 0
      ) {
        todayTotalPeopleData = JSON.parse(
          JSON.stringify(this.stateTodayTotalClients)
        )
        return todayTotalPeopleData
      }

      if (bills.length > 0) {
        todayTotalPeoapleCount = this.getReducedPeopleAmount(bills)

        todayTotalPeopleData = [
          { title: 'confirmados', value: todayTotalPeoapleCount },
          {
            title: 'checkin',
            value:
              todayTotalPeoapleCount - this.checkinCounts.todayNoCheckinCount,
          },
        ]

        if (this.useChartCache == true && this.fetchProgress == 100) {
          this.productStoreCommit({
            mutation: 'SET_TODAY_TOTAL_CLIENTS',
            value: JSON.parse(JSON.stringify(todayTotalPeopleData)),
          })
        }
      }

      return todayTotalPeopleData
    },

    yesterdayTotalClients() {
      let yesterdayTotalPeopleCount = 0
      let date = moment(this.todayReferenceDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD')
      let bills = this.filteredDataCharts.filter(function (val, idx) {
        return val.data.indexOf(date) === 0
      })

      if (
        this.useChartCache &&
        this.stateYesterdayTotalClients != undefined &&
        this.stateYesterdayTotalClients != null &&
        this.stateYesterdayTotalClients > 0
      ) {
        yesterdayTotalPeopleCount = JSON.parse(
          JSON.stringify(this.stateYesterdayTotalClients)
        )
        return yesterdayTotalPeopleCount
      }

      if (bills.length > 0) {
        bills.map((el, index) => {
          if (el.status == 'APPROVED') {
            yesterdayTotalPeopleCount += el.people.tableText.count / 1
          }
        })

        if (this.useChartCache == true && this.fetchProgress == 100) {
          this.productStoreCommit({
            mutation: 'SET_YESTERDAY_TOTAL_CLIENTS',
            value: JSON.parse(JSON.stringify(yesterdayTotalPeopleCount)),
          })
        }
      }
      return yesterdayTotalPeopleCount
    },

    tomorrowTotalClients() {
      let tomorrowTotalPeopleCount = 0
      let date = moment(this.todayReferenceDate)
        .add(1, 'days')
        .format('YYYY-MM-DD')
      let bills = this.filteredDataCharts.filter(function (val, idx) {
        return val.data.indexOf(date) === 0
      })

      if (
        this.useChartCache &&
        this.stateTomorrowTotalClients != undefined &&
        this.stateTomorrowTotalClients != null &&
        this.stateTomorrowTotalClients > 0
      ) {
        tomorrowTotalPeopleCount = JSON.parse(
          JSON.stringify(this.stateTomorrowTotalClients)
        )
        return tomorrowTotalPeopleCount
      }

      if (bills.length > 0) {
        tomorrowTotalPeopleCount = this.getReducedPeopleAmount(bills)

        if (this.useChartCache == true && this.fetchProgress == 100) {
          this.productStoreCommit({
            mutation: 'SET_TOMORROW_TOTAL_CLIENTS',
            value: JSON.parse(JSON.stringify(tomorrowTotalPeopleCount)),
          })
        }
      }

      return tomorrowTotalPeopleCount
    },

    placeName() {
      return this.place.name
    },

    filteredbillItensList() {
      var poi_uuid_list = this.groupBy(this.filteredDataCharts, (product) => {
        return product.poi.uuid
      }).map(function (product, idx) {
        return product[0]
      })

      poi_uuid_list = this.pois
        .filter((product) => poi_uuid_list.indexOf(product.uuid) >= 0)
        .map((prod) => {
          return {
            name: prod.product_place_name + ' - ' + prod.product_name,
            uuid: prod.uuid,
          }
        })
      return [...new Set(poi_uuid_list)]
    },

    filteredbillItensAmount() {
      let defaultFilteredbillItensAmount = [
        { title: '', value: 0 },
        { title: '', value: 0 },
      ]
      let bills = this.filteredDataCharts
      let billItemsFilteredTotalCount = 0

      if (
        this.useChartCache &&
        this.stateFilteredBillItensAmount[0] &&
        this.stateFilteredBillItensAmount[0]['title']
      ) {
        defaultFilteredbillItensAmount = JSON.parse(
          JSON.stringify(this.stateFilteredBillItensAmount)
        )
        return defaultFilteredbillItensAmount
      }

      if (bills.length > 0 && this.fetchProgress == 100) {
        billItemsFilteredTotalCount = this.getReducedPeopleAmount(bills)

        if (this.hasModule('enable_bookings_report')) {
          defaultFilteredbillItensAmount = [
            { title: 'confirmados', value: billItemsFilteredTotalCount },
            {
              title: 'com checkin',
              value: billItemsFilteredTotalCount - this.noCheckinCount,
            },
            {
              title: `${this.clientsCountItemName}/dia`,
              value: (billItemsFilteredTotalCount / this.totalDays)
                .toFixed(0)
                .replace('.', ','),
            },
          ]
        } else {
          defaultFilteredbillItensAmount = [
            { title: 'total', value: billItemsFilteredTotalCount },
            {
              title: `/dia`,
              value: (billItemsFilteredTotalCount / this.totalDays)
                .toFixed(0)
                .replace('.', ','),
            },
          ]
        }

        if (this.useChartCache == true && this.fetchProgress == 100) {
          this.productStoreCommit({
            mutation: 'SET_FILTERED_BILL_ITENS_AMOUNT',
            value: JSON.parse(JSON.stringify(defaultFilteredbillItensAmount)),
          })
        }
      }

      return defaultFilteredbillItensAmount
    },

    billItensList() {
      var bill_items_list = this.groupBy(
        this.transformedItemsArray,
        (product) => {
          return product.poi.uuid || 'AAAAAAAA-0000-AAAA-0000-AAAAAAAAAAAA'
        }
      ).map(function (product, idx) {
        return product[0]
      })
      return [...new Set(bill_items_list)]
    },

    totalDays() {
      var data_diff =
        moment(this.formDate.endDate).diff(
          moment(this.formDate.startDate),
          'days'
        ) + 1
      return data_diff >= 0 || data_diff < 0 ? data_diff : 0
    },

    checkinCounts() {
      var checkin_counts = {
        todayNoCheckinCount: 0,
        yesterdayNoCheckinCount: 0,
        tomorrowNoCheckinCount: 0,
      }
      var vm = this

      if (this.transformedItemsArray.length > 0) {
        this.transformedItemsArray.map(function (value, index) {
          if (!value.checkin.hasCheckin && value.status === 'APPROVED') {
            let _yesterdayReferenceDate = moment(vm.todayReferenceDate)
              .subtract(1, 'days')
              .format('DDMMYYYY')
            let _todayReferenceDate = moment(vm.todayReferenceDate).format(
              'DDMMYYYY'
            )
            let _tomorrowReferenceDate = moment(vm.todayReferenceDate)
              .add(1, 'days')
              .format('DDMMYYYY')
            let billItemDate = moment(value.sdate * 1000).format('DDMMYYYY')

            if (_todayReferenceDate == billItemDate) {
              checkin_counts.todayNoCheckinCount += value.people.tableText.count
            } else if (_yesterdayReferenceDate == billItemDate) {
              checkin_counts.yesterdayNoCheckinCount +=
                value.people.tableText.count
            } else if (_tomorrowReferenceDate == billItemDate) {
              checkin_counts.tomorrowNoCheckinCount +=
                value.people.tableText.count
            }
          }
        })
      }
      return checkin_counts
    },

    filteredDataCharts() {
      if (
        this.selectedbillItensNames.length > 0 &&
        this.billItensList.length > 1
      ) {
        var vm = this
        return vm.transformedItemsArray.filter(function (val, idx) {
          if (vm.selectedbillItensNames.includes(val.poi.product_name)) {
            return val
          }
        })
      } else {
        return this.transformedItemsArray
      }
    },

    transformedItemsArray() {
      return [...this.transformedItems, ...this.trafxEntries]
    },
    otherPOIs() {
      let otherPOIs = []

      this.filteredDataCharts.forEach((booking) => {
        if (!otherPOIs.some((item) => item.uuid == booking.poi.uuid)) {
          otherPOIs.push({
            name: booking.poi.name,
            uuid: booking.poi.uuid,
          })
        }
      })
      return otherPOIs
    },
  },

  data: () => {
    return {
      formDate: { startDate: '', endDate: '' },
      // GROUPPING BY DEEPEST (most nested) CATEGORY
      byCityGraphLevel: 2,
      loadingTableByPaymentMethod: false,
      // activeName: "second",
      //force this date as today e.g. '2022-02-27'
      todayReferenceDate: new Date(),
      loadingTable: false,
      loadingFilter: false,
      inputbillItens: [],
      selectedbillItensNames: [],

      // tableColumns: [],
      defaultBarThickness: 8,
      maxBarThickness: 30,
      // selectedRows: [],
      maxAgentsCols: 1,
      //list: []
      /* Limita a qtd de linhas nos gráficos horizontais */
      verticalChartMaxLines: 20,
      useFakeData: false,
      chartTotalView: 'day',
      showCharts: true,
      chartVisitacaoView: 'city',
      productName: 'object',
      billItemName: 'item',
      reportName: 'visitação',
      billName: 'bill',
      clientsCountItemName: 'itens',
      productCategory: 'cat',
      showFilterSearch: false,
      cacheDurationTime: 5, //refresh cache in minutes
      plurals: {
        'item vendido': 'itens vendidos',
        visitante: 'visitantes',
      },
      billsMemBuffer: [],
      //value of fetchBills progress
      fetchProgress: 0,
      showModalTabelaReservas: false,

      pickerOptions: {
        //TODO: remode this array after migration
        disabledDate(date) {
          let limitedPlacesReport = [
            // '5662C894-ABAE-11EC-8BF6-F23C9227EC8D', //Prefeitura Municipal de Lençóis
            // '2F249056-A778-11EB-9702-5254006CC309', //Prefeitura Municipal de Ibicoara
            // '481E9F40-4B07-11ED-8534-F23C9227EC8D', //Prefeitura Municipal de Mucugê
            // '2F2BCB3C-A778-11EB-9702-5254006CC309', //Baixio Turismo
            // '6FEFDE5F-A2BF-11EF-8851-F23C954BFE7D', //Aldeia Kaí
            // '6A86211A-A2C2-11EF-8851-F23C954BFE7D', //Reserva Pataxó Porto do Boi
            // '7D4B3A93-1719-11EE-8426-F23C9227EC8D', //Prefeitura Municipal de Iraquara
            // 'D012702C-A6EF-11EF-8851-F23C954BFE7D', //Aldeia Gurita
            // '191318F3-A6ED-11EF-8851-F23C954BFE7D', //Aldeia Tibá
            // '14415C12-7CFF-11EF-8851-F23C954BFE7D', //Concessionária SerraMar
            '2F24D331-A778-11EB-9702-5254006CC309', //Parque Nacional da Chapada Diamantina
            // '3342CF7A-1BD5-11EC-9702-5254006CC309', //Complexo Arqueológico Serra das Paridas
            // 'AF61D419-56CB-11ED-8534-F23C9227EC8D', //Fazenda Akã
            // 'E6A15CA6-56EF-11ED-8534-F23C9227EC8D', //Vinícola Vaz
            // 'A3B13D25-6C5B-11EE-8426-F23C9227EC8D', //Ecoparque Pedra da Arara
            // '586D54E3-8327-11EE-8426-F23C9227EC8D', //Gruta da Marota
            // 'CA0359E0-AB40-11EE-8426-F23C9227EC8D', //Tirolesa Buracão
            // 'DC26661A-46C7-11EF-8426-F23C9227EC8D', //Museu Sincorá
            'D488F20F-E989-42AC-81BA-8E5747985ACD', //Pedra da Arara
          ]
          var firstDayOf2024 = moment('2024-01-01')
          if (
            limitedPlacesReport.indexOf(store.getters['auth/user'].placeUuid) >=
            0
          ) {
            firstDayOf2024 = moment('2020-11-01')
          }
          return moment(date).isBefore(firstDayOf2024)
        },
      },
    }
  },

  props: {
    debug: {
      type: Boolean,
      default: false,
    },

    reportMode: {
      //change report behavior
      type: String,
      default: '',
    },
  },

  created() {
    this.fillsFormDate()
    if (process.env.NODE_ENV != 'production') {
      this.todayReferenceDate = moment().format('YYYY-MM-DD')
      window.jdebug = this
    }

    if (this.$route.path == '/reports/visits') {
      this.productStoreCommit({ mutation: 'SET_USE_CHART_CACHE', value: false }) //comment for test cache (disable)
    }

    if (this.isCacheValid()) {
      if (this.reportMode == 'erp') {
        this.productStoreCommit({
          mutation: 'SET_USE_CHART_CACHE',
          value: true,
        }) //comment for test cache (disable)
      }
    } else {
      if (this.showSplash) {
        this.resetChartsCache()
      }
    }

    if (this.hasModule('enable_bookings_report')) {
      const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
      this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })
    }

    this.resetBillsState()

    this.reportName = this.hasModule('enable_bookings_report')
      ? 'Visitação'
      : 'vendas'
    this.productName = this.hasModule('enable_bookings_report')
      ? 'Atrativo(s)'
      : 'Produto(s)'
    this.productNameComplement = this.hasModule('enable_bookings_report')
      ? 'visitados'
      : 'vendidos'
    this.billItemName = this.hasModule('enable_bookings_report')
      ? 'reservas'
      : 'vendas'
    this.finishedBillName = this.hasModule('enable_bookings_report')
      ? 'entrada (checkin)'
      : 'pagamento'
    this.clientsCountItemName = this.hasModule('enable_bookings_report')
      ? 'Visitantes'
      : 'Itens vendidos'
    this.productCategory = this.hasModule('enable_bookings_report')
      ? 'Localização'
      : 'Categoria'
    this.billName = this.hasModule('enable_bookings_report')
      ? 'grupos'
      : 'contas'
    this.reportStoreCommit({ mutation: 'RESET_PRODUCT_LIST' })
  },

  async mounted() {
    if (!this.useChartCache || !this.isCacheValid()) {
      if (this.reportMode == 'erp') {
        await this.productStoreCommit({
          mutation: 'SET_USE_CHART_CACHE',
          value: true,
        })
        this.loadReport()
      }
    } else {
      this.reportStoreCommit({ mutation: 'SET_SHOW_SPLASH', value: false })
    }

    clearTimeout(this.reportReloadTimeout)
    if (new Date(this.getChartCacheLimit).getTime() > new Date().getTime()) {
      if (this.$route.path == '/reports/visits/dashboard') {
        let timeout = setTimeout(() => {
          this.loadReport()
        }, new Date(this.getChartCacheLimit).getTime() - new Date().getTime())
        this.reportStoreCommit({
          mutation: 'SET_REPORT_RELOAD_TIMEOUT',
          value: timeout,
        })
      }

      this.reportStoreCommit({ mutation: 'SET_SHOW_SPLASH', value: false })
    }
  },

  methods: {
    ...mapActions('report', [
      'fetchBillItems',
      'resetBillsState',
      'removeBufferItem',
      'reportStoreCommit',
      'getBillsMemBuffer',
      'removeMemBufferItem',
      'clearReportCacheFlags',
    ]),

    ...mapActions('trafx', ['fetchTrafxEntriesByDate', 'trafxStoreCommit']),

    ...mapActions('product', [
      'fetchPOIs',
      'productStoreCommit',
      'resetChartsCache',
    ]),

    ...mapActions('financeiro', ['financeiroStoreCommit']),

    isCacheValid() {
      return (
        this.getChartCacheLimit &&
        this.getChartCacheLimit > new Date().getTime()
      )
    },

    async invalidateCache() {
      if (this.showSplash) {
        await this.resetChartsCache()
      }
    },

    getReducedPeopleAmount(billItens) {
      return billItens
        .map((cur) => {
          let peopleCount = 0
          if (cur.status == 'APPROVED') {
            peopleCount = Number(cur.people.tableText.count)
          }
          return peopleCount
        })
        .reduce((prev, cur) => {
          return prev + cur
        })
    },

    getUploads() {
      const form = {
        UUID: this.user.uuid || this.place.janooUserUuid,
        start_date: this.formDate.startDate,
        end_date: this.formDate.endDate,
      }
      // this.fetchTrafxEntriesByDate(form)
    },

    plural(term) {
      term = term.toLowerCase()
      let convertedIndex = Object.keys(this.plurals).indexOf(term)
      let convertedTerm = ''
      if (convertedIndex >= 0) {
        convertedTerm = Object.values(this.plurals)[convertedIndex]
      } else {
        convertedIndex = Object.values(this.plurals).indexOf(term)
        convertedTerm = Object.keys(this.plurals)[convertedIndex]
      }
      return convertedTerm
    },

    changeUseChartCache(payload) {
      this.productStoreCommit({
        mutation: 'SET_USE_CHART_CACHE',
        value: payload,
      })
    },

    openModalTabelaReservas() {
      this.showModalTabelaReservas = true
    },
    closeModalTabelaReservas() {
      this.showModalTabelaReservas = false
    },

    downloadAsCSV() {
      var csvData = []
      var current_booking_agents = {}
      var bookings_report_enabled = this.hasModule('enable_bookings_report')
      var _maxAgentsCols = _maxAgentsCols
      if (typeof this.transformedItemsArray == 'object') {
        csvData = Object.values(this.transformedItemsArray).map(function (val) {
          // GROUPPING BY DEEPEST CATEGORY
          // let deeper_cat = val.cat.slice(-1)
          // deeper_cat = deeper_cat.pop()
          // deeper_cat = deeper_cat.slice(-1).pop()
          // deeper_cat = deeper_cat.description || deeper_cat.name
          var row = [
            // Reserva
            `"${val.code || val.id}"`,
            //atrativo
            `"${val.poi.name}"`,
            //Cat, Muniícpio
            val.cat,
            //...	QRCode, Conta Bocapio
            val.linkQrCode == undefined || val.linkQrCode.includes('undefined')
              ? `${window.location.origin}/booking-details/${val.code}`
              : val.linkQrCode.replace(/\\/g, ''),
            //Status Reserva, Status do Item de compra
            val.status,
            //#Pedido
            // val.bid,
            // val.date_created,
            //Agendado para
            new Date(val.sdate * 1000).toISOString().split('T')[0],
            //Check-in
            (
              val.checkin.searchText +
              ', ' +
              moment(val.checkin.dateTime * 1000).format('YYYY-MM-DD HH:mm')
            ).replaceAll(',', ' | '),
            //Pessoas
            val.people.tableText.count,
            //Pagador
            val.people.tableText.groupOwner
              ? val.people.tableText.groupOwner.replaceAll(',', ' | ')
              : '',
          ]

          if (!bookings_report_enabled) {
            //Valor total
            row.push(val.finalValue)
            //Forma de pagamento
            row.push(val.paymentMethod)
            //Confirmação de pagamento
            row.push(JSON.stringify(val.confirmPayment.tableText) || '')
          }

          val.agents.forEach((agent) => {
            var agent_name = agent.name
            if (current_booking_agents[agent.UUID + '-' + val.id]) {
              return
            }
            current_booking_agents[agent.UUID + '-' + val.id] = 1
            var agent_nickname = agent.nickname
            var agent_placename = agent.place
            if (agent_nickname != null && agent_nickname) {
              agent_name += ' - ' + agent_nickname
            }
            row.push(agent_name)

            if (agent_placename == undefined) {
              agent_placename = ''
            }
            row.push(agent_placename)
          })
          return row
        })
      }

      var headers = []
      //Using node.js API
      if (bookings_report_enabled) {
        headers = [
          'ID',
          'Atrativo',
          'Localização',
          'QRCode',
          'Status',
          'Agendado para',
          'Checkin',
          'Qtd. Pessoas',
          'Responsável',
          //'Valor', 'Forma de pagamento', 'Status pagamento',
        ]
        for (var i = 0; i < this.maxAgentsCols; i++) {
          headers.push('Condutor ' + (i + 1))
          headers.push('Associação ' + (i + 1))
        }
        csvData.unshift(headers)
      } else {
        headers = [
          'ID',
          'Produto',
          'Categoria',
          'Conta',
          'Status da Venda',
          'ID da Conta',
          'Status da Conta',
          'Data de compra',
          'OBS',
          'Quatidade',
          'Cliente',
          'Valor total',
          'Forma de pagamento',
          'Status pagamento',
        ]
        csvData.unshift(headers)
      }
      this.createCSVFile(csvData, 'relatorio_visitacao')
    },

    downloadAsAgentCSV() {
      var csvData = []
      var current_booking_agents = {}
      var report_agents = {}
      var bookings_report_enabled = this.hasModule('enable_bookings_report')
      var _maxAgentsCols = _maxAgentsCols
      var headers = ['Condutor/Data']
      let dt = new Date(this.formDate.startDate + ' 00:00:00')
      let edate = new Date(this.formDate.endDate + ' 23:59:59')

      while (dt <= edate) {
        headers.push(dt.toISOString().substr(0, 10))
        dt.setDate(dt.getDate() + 1)
      }

      // headers.push('')
      headers.push('TOTAL GUIADAS')
      headers.push('TOTAL VISITANTES')
      csvData.unshift(headers)

      if (typeof this.transformedItemsArray == 'object') {
        Object.values(this.transformedItemsArray).forEach(function (val) {
          let startDate = new Date(val.sdate * 1000).toISOString().split('T')[0]
          val.agents.forEach((agent) => {
            try {
              agent = JSON.parse(atob(agent.value))
            } catch (error) {}

            var agent_name = agent.name
            if (current_booking_agents[agent.UUID + '-' + val.id]) {
              return
            }

            current_booking_agents[agent.UUID + '-' + val.id] = 1
            var agent_nickname = agent.nickname
            var agent_placename = agent.place

            if (agent_nickname != null && agent_nickname.trim() != '') {
              agent_name += ' - ' + agent_nickname
            }

            if (agent_placename != undefined) {
              agent_placename = agent_placename.split('-')[0]
              agent_placename = ' | ' + agent_placename
            } else {
              agent_placename = ''
            }

            let uuidCSV = agent_name + agent_placename
            uuidCSV = uuidCSV.replace(/ /g, '')

            if (undefined == report_agents[uuidCSV]) {
              report_agents[uuidCSV] = new Array(headers.length - 2).fill('')
              report_agents[uuidCSV][0] = agent_name + agent_placename

              report_agents[uuidCSV][headers.length - 2] = 0 //total guiadas
              report_agents[uuidCSV][headers.length - 1] = 0 //total visitantes
            }

            let dayIndex = headers.indexOf(startDate)
            //1 column before cosidering column name
            if (report_agents[uuidCSV][dayIndex] == '') {
              report_agents[uuidCSV][dayIndex] = 0
            }

            report_agents[uuidCSV][dayIndex] += val.people.tableText.count / 1
            report_agents[uuidCSV][headers.length - 2] += 1 //total guiadas
            report_agents[uuidCSV][headers.length - 1] +=
              val.people.tableText.count //total visitantes
          })
        })
      }

      let ordered_report_agents = Object.keys(report_agents).sort()
      ordered_report_agents.forEach((agent) => {
        csvData.push([...report_agents[agent]])
      })

      csvData = csvData.map(function (value, index) {
        return value.map(function (val, idx) {
          if (val == undefined) {
            val = ''
          }
          return val
        })
      })

      this.createCSVFile(csvData, 'atuacao_por_condutor')
    },

    downloadAsAssocCSV() {
      var csvData = []
      var current_booking_agents = {}
      var report_agents = {}
      var bookings_report_enabled = this.hasModule('enable_bookings_report')
      var _maxAgentsCols = _maxAgentsCols
      var headers = ['Associação/Data']
      let dt = new Date(this.formDate.startDate + ' 00:00:00')
      let edate = new Date(this.formDate.endDate + ' 23:59:59')

      while (dt <= edate) {
        headers.push(dt.toISOString().substr(0, 10))
        dt.setDate(dt.getDate() + 1)
      }

      headers.push('')
      headers.push('TOTAL GUIADAS')
      headers.push('TOTAL VISITANTES')
      csvData.unshift(headers)

      if (typeof this.transformedItemsArray == 'object') {
        Object.values(this.transformedItemsArray).forEach(function (val) {
          let startDate = new Date(val.sdate * 1000).toISOString().split('T')[0]
          val.agents.forEach((agent) => {
            try {
              agent = JSON.parse(atob(agent.value))
            } catch (error) {}

            var agent_placename = agent.place
            if (current_booking_agents[agent.UUID + '-' + val.id]) {
              return
            }

            current_booking_agents[agent.UUID + '-' + val.id] = 1

            if (agent_placename != undefined) {
              agent_placename = agent_placename.split('-')[0]
            } else {
              agent_placename = 'NÃO INFORMADO'
            }

            let uuidCSV = agent_placename
            uuidCSV = uuidCSV.replace(/ /g, '')
            if (undefined == report_agents[uuidCSV]) {
              report_agents[uuidCSV] = new Array(headers.length - 3).fill('')
              report_agents[uuidCSV][0] = agent_placename
              //total guiadas
              report_agents[uuidCSV][headers.length - 2] = 0
              //total visitantes
              report_agents[uuidCSV][headers.length - 1] = 0
            }

            let dayIndex = headers.indexOf(startDate)
            //1 column before cosidering column name
            if (report_agents[uuidCSV][dayIndex] == '') {
              report_agents[uuidCSV][dayIndex] = 0
            }

            report_agents[uuidCSV][dayIndex] += val.people.tableText.count
            //total guiadas
            report_agents[uuidCSV][headers.length - 2] += 1
            //total visitantes
            report_agents[uuidCSV][headers.length - 1] +=
              val.people.tableText.count
          })
        })
      }

      let ordered_report_agents = Object.keys(report_agents).sort()
      ordered_report_agents.forEach((agent) => {
        csvData.push([...report_agents[agent]])
      })
      this.createCSVFile(csvData, 'atuacao_por_associacao')
    },

    createCSVFile(csvData, fileSufix) {
      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        csvData.map((e) => e.join(';')).join('\n')
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_${fileSufix}_janoo.csv`
      )
      jQuery('body')
        .append(link)
        .ready(function () {
          link.click()
        })
    },

    async loadReport() {
      if (!this.formDate.startDate) {
        this.formDate.startDate = moment(this.todayReferenceDate)
          .startOf('month')
          .format('YYYY-MM-DD')
      }

      if (!this.formDate.endDate) {
        this.formDate.endDate = moment(this.todayReferenceDate)
          .endOf('month')
          .format('YYYY-MM-DD')
      }

      var diff = moment(this.formDate.endDate).diff(
        moment(this.formDate.startDate),
        'days'
      )
      if (diff < 0) {
        swal.fire({
          title: `Atenção!`,
          text: `a data final deve ser após a data inicial!`,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
        })
        this.formDate.endDate = this.formDate.startDate
      }

      if (diff > 365) {
        this.$notify({
          message:
            'A data final deve ser no máximo 365 dias após a data inicial',
          duration: 60000,
          type: 'error',
        })
        this.formDate.endDate = moment(this.formDate.startDate)
          .add(365, 'days')
          .format('YYYY-MM-DD')
        return
      }

      this.loadingTable = true
      this.loadingFilter = true
      this.loadingTableByPaymentMethod = true

      const params = {
        startDate: this.formDate.startDate,
        endDate: this.formDate.endDate,
        useFakeData: this.useFakeData,
        daysInternval: 1,
        operation_request: false,
      }

      this.clearReportCacheFlags()
      this.calculateFetchProgress()
      this.fetchBillItems(params)
      this.fetchBillsAwait()
      this.getUploads()
    },

    fetchBillsAwait(idx) {
      this.getBillsMemBuffer().then((bufferData) => {
        this.billsMemBuffer = bufferData
      })

      if (!idx) {
        idx = 1
      }
      if (this.billsMemBuffer.length >= idx) {
        this.removeMemBufferItem(idx - 1)
        idx++
      }

      let doneStatusCount = this.$store.state.report.requestArrayStatus.filter(
        (resp) => resp == 'done'
      ).length
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      let doneBufferCount = this.billsMemBuffer.filter(
        (resp) => resp == 0
      ).length

      if (
        doneStatusCount == 0 ||
        doneStatusCount < totalRequest ||
        doneBufferCount < totalRequest
      ) {
        setTimeout(
          (i, cb) => {
            this.fetchBillsAwait(i, cb)
          },
          100,
          idx
        )
      } else {
        this.loadingTable = false
        this.loadingFilter = false
        this.loadingTableByPaymentMethod = false

        this.reportStoreCommit({ mutation: 'SET_SHOW_SPLASH', value: false })
        this.productStoreCommit({
          mutation: 'SET_CACHE_LIMIT_DATE',
          value: this.cacheDurationTime,
        })
        clearTimeout(this.reportReloadTimeout)
        // if (this.$route.path == '/reports/visits/dashboard') {
        //   let timeout = setTimeout(() => {
        //     this.loadReport()
        //   console.log('auto reloading 2...')
        //   }, this.cacheDurationTime * 60000)
        //   this.reportStoreCommit({ mutation: "SET_REPORT_RELOAD_TIMEOUT", value: timeout })
        // }
      }
      this.calculateFetchProgress()
    },

    fillsFormDate() {
      if (this.reportMode == 'erp') {
        this.formDate.startDate = moment(this.todayReferenceDate)
          .startOf('month')
          .format('YYYY-MM-DD')
        this.formDate.endDate = moment(this.todayReferenceDate)
          .endOf('month')
          .format('YYYY-MM-DD')
      }
    },

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)

        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return Array.from(map)
    },

    setInputbillItens(billItensNames) {
      this.loadingTable = true
      this.selectedbillItensNames = billItensNames
      setTimeout(this.removeLoading, 0)
    },

    removeLoading() {
      this.loadingTable = false
    },

    hasModule(module) {
      let modules = []
      try {
        modules = this.params.User.modules
        if (typeof modules == 'string') {
          let _modules = []
          _modules[modules] = modules
          modules = _modules
        }
        modules = Object.keys(modules)
      } catch (error) {
        console.warn('nenhum módulo encontrado')
      }
      return modules.indexOf(module) >= 0
    },

    calculateFetchProgress() {
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      var done = this.billsMemBuffer.filter((resp) => resp == 0).length
      let progress = (done / totalRequest) * 100
      this.fetchProgress = done > 0 ? progress : 0.1
    },
  },
}
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border 0.75s linear infinite;
  animation: spinner-border 0.75s linear infinite;
}
</style>

<style lang="css">
.full-modal .modal-content {
  height: 94vh;
}

.full-modal .modal-dialog {
  transition: none;
}

.full-modal .modal-body {
  padding: 0 1.5rem;
}

.full-modal .fade,
.full-modal .modal.fade .modal-dialog,
.full-modal .modal-content {
  transition: none;
  -webkit-transition: none;
}

.full-modal .progress .progress-bar {
  color: transparent;
}

.full-modal,
.full-modal .modal-content {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
  background-color: #f5f9f9;
}
</style>
